'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { RootFallback } from '@app/_components/RootFallback';
import { useSentry } from '@hooks/useSentry';
import { reloadIfStaleServerAction } from '@lib/errors/reloadIfStaleServerAction';
import type { FC } from 'react';
type Props = Readonly<{
  error: Error;
  digest?: string;
}>;
const GlobalError: FC<Props> = t0 => {
  const $ = _c(5);
  const {
    error
  } = t0;
  const {
    captureException
  } = useSentry();
  let t1;
  let t2;
  if ($[0] !== captureException || $[1] !== error) {
    t1 = () => {
      if (reloadIfStaleServerAction(error)) {
        return;
      }
      captureException(error);
    };
    t2 = [captureException, error];
    $[0] = captureException;
    $[1] = error;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <html lang="en"><body><RootFallback title="Something went wrong!"><p style={{
            margin: 0
          }}>Please refresh the browser.</p></RootFallback></body></html>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default GlobalError;